import { get } from "./utils";

export const administrative = {
  tree: (parameters, token) => {
    return get("/api/basis/administratives/tree/", parameters, token);
  },
};

